module.exports = __webpack_public_path__ + "static/img/resolvent4.573033c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/resolvent4.png
// module id = PnKV
// module chunks = 13